import { PropsWithChildren } from 'react';

import cn from 'classnames';

export interface TableBodyCellProps {
  /**
   * Controls right padding in the table cell. Default `true`, except for the last column
   * @default true
   */
  hasRightPadding?: boolean;
}

export const TableBodyCell = ({
  children,
  hasRightPadding,
}: PropsWithChildren<TableBodyCellProps>) => (
  <div
    className={cn('flex justify-start py-3 items-center max-xl-msq:py-1', {
      'pr-0': !hasRightPadding,
      'pr-4': hasRightPadding,
    })}
  >
    {children}
  </div>
);
